import { FC } from 'react';
import { Outlet } from 'react-router';

const SecureAppWrapper: FC = () => {
    return <Outlet />;
};

export default SecureAppWrapper;
